var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_851",
    "data-name": "Groupe 851",
    transform: "translate(-133 -149)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 80.5,
    cy: 80.5,
    r: 80.5,
    transform: "translate(133 149)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-avatar-filled-alt",
    transform: "translate(132.813 149.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_665",
    "data-name": "Trac\\xE9 665",
    d: "M80.187,2.25a77.937,77.937,0,1,0,77.938,77.937A77.937,77.937,0,0,0,80.187,2.25Zm44.536,127.59v-3.385A29,29,0,0,0,96.888,96.888h-33.4a28.948,28.948,0,0,0-27.78,29.562c0,.059-.054.124-.054.183v3.256a66.833,66.833,0,1,1,89.071-.054Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_666",
    "data-name": "Trac\\xE9 666",
    d: "M40.21,7.875A27.835,27.835,0,1,0,68.045,35.71,27.835,27.835,0,0,0,40.21,7.875Z",
    transform: "translate(39.978 22.21)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.8e43034156e2305ed926240200938d8c.svg";
export { ForwardRef as ReactComponent };